import { Button, Field, Form } from "web/components"
import { useState, useCallback, useEffect, useRef } from "react"

export default function LockedFieldForm({
  fieldKey,
  field,
  fieldValue,
  rowData,
  closeModal,
  globalValue,
}) {
  const [lockedFieldValue, setLockedFieldValue] = useState(
    fieldValue?.value ?? null
  )
  const [isSubmitting, setIsSubmitting] = useState(false)
  const isMounted = useRef(true)

  useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  const saveLockedFieldValue = useCallback(async () => {
    const update = { [field.key]: lockedFieldValue }

    const formattedUpdate = {
      [field.key]: { value: update, form_value: update },
    }

    const newLocalData = {
      ...rowData,
      values: { ...rowData.values, ...formattedUpdate },
    }

    setIsSubmitting(true)

    try {
      await rowData.update(update, newLocalData)

      if (isMounted.current) {
        closeModal()
      }
    } finally {
      if (isMounted.current) {
        setIsSubmitting(false)
      }
    }
  }, [field.key, lockedFieldValue, rowData, closeModal])

  const handleChange = useCallback((_, value) => {
    setLockedFieldValue(value)
  }, [])

  const workflowName = rowData.values.deal_workflow?.value?.value
  const workflowStageName = rowData.locked_fields[fieldKey]

  return (
    <>
      <Form
        fields={[field]}
        globalValue={globalValue}
        onSubmit={saveLockedFieldValue}
        render={(form) => (
          <>
            <div className="modal-content-above-commands dialog-prompt space-y-6 overflow-hidden">
              <p>
                {field.label} is locked within the{" "}
                <strong>{workflowStageName}</strong> stage of the{" "}
                <strong>{workflowName}</strong> Workflow.
              </p>
              <Field
                fieldKey={fieldKey}
                value={lockedFieldValue}
                onFieldChange={handleChange}
              />
            </div>
            <div className="modal-commands">
              <div className="right-buttons">
                <Button
                  variant="secondary_default"
                  onClick={closeModal}
                  type="button"
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => form.submit()}
                  disabled={!form.isValid || isSubmitting}
                  variant="primary_danger"
                  disableAfterClick
                >
                  {isSubmitting ? "Saving..." : "Save"}
                </Button>
              </div>
            </div>
          </>
        )}
      />
    </>
  )
}
